export type TableWidgetPointXAxisValue = number;
export type TableWidgetPointYAxisValue = number | [number, number, number];
export type TableWidgetPointInterpolation = boolean;
export type TableWidgetPointBucketInfo = {
  count: number;
  sum: number;
  positiveInfCount: number;
  negativeInfCount: number;
  nanCount: number;
};

export type TableWidgetPoint = [
  TableWidgetPointXAxisValue,
  TableWidgetPointYAxisValue,
  undefined?,
  undefined?,
  TableWidgetPointInterpolation?,
  TableWidgetPointBucketInfo?,
];

export function getTableWidgetPointX(point: TableWidgetPoint): TableWidgetPointXAxisValue {
  return point[0];
}

export function getTableWidgetPointValue(point: TableWidgetPoint): number {
  return Array.isArray(point[1]) ? point[1][1] : point[1];
}

export function getTableWidgetPointInterpolationFlag(
  point: TableWidgetPoint,
): TableWidgetPointInterpolation | undefined {
  return point[4];
}
